<template>
    <div class="three">
        <div class="title">
            <div class="left-box"></div>
            <div class="right-box">报修渠道分析</div>
        </div>
        <div class="main" id="main-info"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    data() {
        return {
            myChart: "",
            data: {
                begin: "2018-01-01 00:00:00",
                end: "3000-01-01 00:00:00",
            },
            xAxisArr: [],
            yAxisArr: [],
        };
    },
    mounted() {
        this.load()
    },
    methods: {
        load() {
            $utils.api.load("StateWorkType", this.data, "get").then((res) => {
                console.log(res);
                let that = this;
                if (res.code == 200) {
                    that.xAxisArr = [];
                    that.yAxisArr = [];
                    res.data.forEach((res) => {
                        that.xAxisArr.push(res.title);
                        that.yAxisArr.push(res.percentage);
                    });
                    this.echartsFun();
                }
            });
        },
        echartsFun() {
            let chartMain = document.getElementById("main-info");
            this.myChart = echarts.init(chartMain);
            let option = {
                grid: {
                    left: "7%",
                    right: "5%",
                    top: "5%",
                    bottom: "10%",
                },
                xAxis: {
                    type: "category",
                    data: this.xAxisArr,
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#999",
                        },
                    },
                    nameTextStyle: {
                        fontSize: 14,
                        color: "#000",
                        width: 50,
                        overflow: 'break',
                    },
                    axisLabel: {
                        interval: 0,
                        fontSize: 14,
                        color: "#000",
                        margin: 0,
                        padding: [8, 0, 0, 0],
                    },
                },
                yAxis: {
                    type: "value",
                    min: 0,
                    max: 100,
                    interval: 20,
                    axisLabel: {
                        color: "#666",
                        verticalAlign: "middle",
                        formatter: "{value} %",
                        fontSize: 16
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: "dotted",
                        },
                    },
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                },
                series: [
                    {
                        data: this.yAxisArr,
                        type: "bar",
                        label: {
                            show: true,
                            position: "top",
                            formatter: "{c}%",
                            fontSize: 18
                        },
                        itemStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: "rgba(64, 158, 255, 0.1)" },
                                { offset: 0.5, color: "rgba(64, 158, 255, 0.5)" },
                                { offset: 1, color: "rgba(64, 158, 255, 1)" },
                            ]),
                        },
                    },
                ],
            };
            option && this.myChart.setOption(option);
            window.addEventListener('resize', () => {
                this.myChart.resize()
            })
        },
    },
};
</script>

<style scoped lang="scss">
.three {
    width: 100%;
    height: 600px;
    padding: 10px;

    .title {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .left-box {
            width: 10px;
            height: 20px;
            border-radius: 1px;
            margin-right: 8px;
            background-color: #46a6ff;
        }

        .right-box {
            font-weight: 600;
            color: black;
        }
    }


    .main {
        width: 100%;
        height: 500px;
        background: #fff;
        padding-top: 20px;
    }
}

.ivu-radio-group-button-solid .ivu-radio-wrapper-checked:not(.ivu-radio-wrapper-disabled) {
    background: #46a6ff;
    color: #fff;
}

.ivu-radio-group-button .ivu-radio-wrapper-checked {
    border-color: #46a6ff;
    box-shadow: -1px 0 0 0 #46a6ff;
    z-index: 1;
}

.ivu-radio-group-button .ivu-radio-wrapper:hover {
    position: relative;
    color: #46a6ff;
}

.ivu-radio-group-button-solid .ivu-radio-wrapper-checked:not(.ivu-radio-wrapper-disabled):hover {
    background: #46a6ff;
}

.ivu-radio-group-button .ivu-radio-wrapper-checked:hover {
    border-color: #46a6ff;
}

.ivu-radio-group-button .ivu-radio-wrapper-checked.ivu-radio-focus {
    box-shadow: none;
    transition: none;
}

.iwu-btn-primary:focus {
    box-shadow: none;
}

.ivu-btn:focus {
    box-shadow: none;
}

.ivu-radio-group-button .ivu-radio-wrapper-checked:before {
    background: none;
    opacity: 0;
}

.ivu-radio-group-button .ivu-radio-wrapper:before,
.ivu-radio-group-button .ivu-radio-wrapper:after {
    background: none;
    transition: none;
}

.ivu-radio-group-button .ivu-radio-wrapper:after {
    background: none;
    opacity: 0;
}

.ivu-radio-group-button .ivu-radio-wrapper:before,
.ivu-radio-group-button .ivu-radio-wrapper:after {
    background: none;
}

.ivu-radio-group-button .ivu-radio-wrapper-checked:first-child {
    border: none;
}

.ivu-radio-group-button .ivu-radio-wrapper-checked.ivu-radio-focus:first-child {
    box-shadow: none;
}

.ivu-radio-group-button .ivu-radio-wrapper-checked.ivu-radio-focus:after {
    opacity: 0;
}
</style>
